import React, { FC } from 'react';

import { Post } from '~/api/blog/blogTypes';
import { AuthorLink, AuthorPostLink } from '~/atomic/atom/links/dynamicLinks';
import { BookStatus } from '~/atomic/molecula/BookStatus';
import { getPostThemeName } from '~/feature/blogs/EditPostCard';
import {
  SCAuthorPostCard,
  SCDatePostCard,
  SCHeaderPostCard,
  SCMainPostCard, SCPostButton,
  SCPostCard, SCPostCommentsIcon, SCPostCommentsWrapper, SCPostCount,
  SCTextPostCard,
  SCTitlePostCard,
  SCTitlePostCardLink,
} from '~/feature/blogs/postCardStyle';
import { usePostContentFotmatting } from '~/feature/blogs/postContentFotmatting';
import {
  MAX_MOBILE_POST_CARD_CONTENT_LENGTH,
  MAX_POST_CARD_CONTENT_LENGTH,
} from '~/feature/blogs/ViewPostCard';
import { isMobileSizeSelector } from '~/feature/media/windowSize.selector';
import { DateFormatComponent } from '~/lib/dateFormatText';
import { useAppSelector } from '~/store';

export const AuthorPostCard: FC<{ post: Post }> = ({ post }) => {
  const isMobileSize = useAppSelector(isMobileSizeSelector);
  const postContent = usePostContentFotmatting(
    post.content,
    isMobileSize ? MAX_MOBILE_POST_CARD_CONTENT_LENGTH : MAX_POST_CARD_CONTENT_LENGTH,
  );

  return (
    <SCPostCard>
      <SCMainPostCard>
        <SCHeaderPostCard>
          <AuthorPostLink
            slugPost={post.slug}
          >
            <SCTitlePostCardLink>
              <SCTitlePostCard>
                {post.title}
              </SCTitlePostCard>
            </SCTitlePostCardLink>
          </AuthorPostLink>
          <AuthorLink
            username={post?.author?.username ?? ''}
          >
            <SCAuthorPostCard>
              {post?.author?.name ?? ''}
            </SCAuthorPostCard>
          </AuthorLink>
          {post?.publishedAt && (
            <SCDatePostCard>
              <DateFormatComponent date={post?.publishedAt ?? new Date()} />
            </SCDatePostCard>
          )}
          <BookStatus text={getPostThemeName(post?.theme)} type="theme" />
          {post.counters.comments ? (
            <SCPostCommentsWrapper>
              <SCPostCommentsIcon />
              <SCPostCount>{post.counters.comments}</SCPostCount>
            </SCPostCommentsWrapper>
          ) : null}
        </SCHeaderPostCard>
        <SCTextPostCard
          dangerouslySetInnerHTML={{ __html: postContent }}
        />
        <AuthorPostLink slugPost={post.slug}>
          <a>
            <SCPostButton
              size="small"
              style={{ marginTop: '8px' }}
            >
              Читать дальше
            </SCPostButton>
          </a>
        </AuthorPostLink>
      </SCMainPostCard>
    </SCPostCard>
  );
};
